// extracted by mini-css-extract-plugin
export default {"fullCustomDropdown":"UserList_fullCustomDropdown__LJ7dI"};